// extracted by mini-css-extract-plugin
export var chevronIcon = "_dn-2";
export var teamName = "_dn-1";
export var teamSwitcherButton = "_dn-0";